import React, { useEffect, useState, useContext } from "react"; // Importing necessary modules from React
import { ModalProvider, ModalContext } from "../../../components/modal/modalContext"; // Importing ModalProvider and ModalContext
import Marquee from "react-fast-marquee"; // Importing Marquee component
import { useHistory } from "react-router-dom"; // Importing useHistory hook from react-router-dom
import { useLocation } from 'react-router-dom';
import { LazyLoadImage } from "react-lazy-load-image-component"; // Importing LazyLoadImage component
import Skeleton from "@mui/material/Skeleton"; // Importing Skeleton component from Material-UI
import placeHolderH from "../../../assets/images/placeholder.jpg"; // Importing placeholder image
import placeHolderV from "../../../assets/images/placeholder_v.jpg"; // Importing vertical placeholder image
import PlayIcon from "../../../assets/images/play1.svg"; // Importing play icon image

import ZoomThumbnail from "./zoomThumbnail"; // Importing ZoomThumbnail component
import CustomModal from "../../modal/modalCustom"; // Importing CustomModal component
import VideoPlayerComponent from "../../VideoPlayer"; // Importing VideoPlayerComponent
import PopupPlayer from "../../PopupPlayer"; // Importing PopupPlayer component
import { IoPlayOutline } from "react-icons/io5"; // Importing IoPlayOutline icon from react-icons/io5
import parse from "html-react-parser"; // Importing parse function from html-react-parser library

import { MyContext } from "../../../PageRouters/layouts/publicLayout"; // Importing MyContext from publicLayout.js
const CommonCard = (props) => { // Functional component definition with props parameter
  const context = useContext(MyContext); // Using useContext hook to get context from MyContext
  const [muted, setMuted] = useState(false); // State variable for mute status
  const { openModal, setCustomModal } = useContext(ModalContext); // Using useContext hook to get openModal and setCustomModal functions from ModalContext
  const [open, setOpen] = React.useState(false); // State variable for modal open status
  const [url, setUrl] = React.useState(null); // State variable for URL
  const [AudioUrl, setAudioUrl] = React.useState(null); // State variable for URL
  const [isOpen, setIsopen] = React.useState(false); // State variable for modal open status
  const history = useHistory(); // Getting history object from useHistory hook for navigation
  const location = useLocation();


  const handelNavigation = (props) => { // Function for handling navigation

    //  statement for debugging purposes
    const { cattype, item, compleatepops, currentrowData, contenttype } = props; // Destructuring props
    const sanitizedCatName = encodeURIComponent(item?.name.replace(/[|:;.,\s]/g, "").toLowerCase()); // Sanitizing category name for URL
    const entryId = item?.entryid ?? ''; // Getting entry ID, defaulting to an empty string if not available
    const itemId = item?.id ?? ''; // Getting item ID, defaulting to an empty string if not available

    // Navigation logic based on video type
    if (item?.video_type === "pdf") { // Handling PDF type

      document.body.classList.remove('radioOpen'); // Removing 'radioOpen' class from body
      context.setisOpenRadio(false); // Setting isOpenRadio state to false in context
      // document.querySelector('html').classList.add('overflow-hidden'); // Adding 'overflow-hidden' class to HTML element
      setIsopen(true); // Setting isOpen state to true
      const urlLink = item?.download_url;
      // Open the URL in a new tab
      // window.open(urlLink, '_blank');
    }
    if (item?.video_type === "rss_feed") { // Handling RSS feed type
      try {

        if (entryId || itemId) { // Checking if entryId or itemId exists
          const url = `/feeds/${cattype ? cattype : 'cat'}/${sanitizedCatName}/${entryId || itemId}`; // Constructing URL
          history.push({ // Navigating to URL
            pathname: url,
            state: {
              cattype: cattype ?? '',
              entryid: entryId ?? '',
              catid: itemId ?? '',

            }
          });
        } else {
          // Handle case where both entryId and itemId are empty
        }
      } catch (error) {
        // Handle error
      }
    }
    if (item?.video_type === "youtube") { // Handling YouTube type
      document.body.classList.remove('radioOpen'); // Removing 'radioOpen' class from body
      context.setisOpenRadio(false); // Setting isOpenRadio state to false in context
      setUrl(''); // Clearing URL state
      setOpen(true); // Setting open state to true
    }
    if (item?.video_type === "live") {
      // Handling Live type
      setUrl(''); // Clearing URL state
      // //
      setAudioUrl(item.audio_url)
      document.body.classList.remove('radioOpen'); // Removing 'radioOpen' class from body
      context.setisOpenRadio(false); // Setting isOpenRadio state to false in context
      context.setIsPopup(true); //
      setOpen(true); // Setting open state to true
      document.querySelector('html').classList.add('overflow-hidden'); // Adding 'overflow-hidden' class to HTML element
    }
    if (item?.video_type === "audio") {
      // Handling Audio type

      const currentPath = location.pathname;
      // console.log('currentPath', currentPath)
      if (currentPath === "/search") {
        try {
          if (entryId || itemId) { // Checking if entryId or itemId exists
            const url = `/radioview/${cattype ? cattype : 'cat'}/${sanitizedCatName}/${entryId || itemId}`; // Constructing URL
            history.push({ // Navigating to URL
              pathname: url,
              state: {
                cattype: cattype ?? '',
                entryid: entryId ?? '',
                catid: itemId ?? '',
                play: props.play,
                currentsong: item,
                isSeries: props.isSeries,
                isRecommended: props.isRecommended,
                recommend: undefined,
                sereis: undefined
              }
            });
          }
        } catch (error) {

        }
      } else {
        if (cattype !== 'subseries') {
          if (entryId || itemId) { // Checking if entryId or itemId exists
            const url = `/radioview/${cattype ? cattype : 'cat'}/${sanitizedCatName}/${entryId || itemId}`; // Constructing URL
            history.push({ // Navigating to URL
              pathname: url,
              state: {
                cattype: cattype ?? '',
                entryid: entryId ?? '',
                catid: itemId ?? '',
                currentsong: item,
                play: props.play,
                isRecommended: props.isRecommended,
                recommend: props.recomendedData,
                sereis: props.seriesItems,

              }
            });
          }
        } else {

          context.setplaySongIndex(props.play)
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        }
      }

    }
    if (item?.video_type === "video") { // Handling Video type
      document.body.classList.remove('radioOpen'); // Removing 'radioOpen' class from body
      context.setisOpenRadio(false); // Setting isOpenRadio state to false in context
      try {
        if (entryId || itemId) { // Checking if entryId or itemId exists
          const url = `/watch/${cattype ? cattype : 'cat'}/${sanitizedCatName}/${entryId || itemId}`; // Constructing URL
          history.push({ // Navigating to URL
            pathname: url,
            state: {
              cattype: cattype ?? '',
              entryid: entryId ?? '',
              catid: itemId ?? '',
              isInnercard: props.isInnercard
            }
          });
        } else {
          // Handle case where both entryId and itemId are empty
        }
      } catch (error) {
        // Handle error
      }
    }
  };

  const isMuted = () => { // Function for toggling mute status
    setMuted(!muted);
  };

  const handleClose = () => { // Function for handling modal close
    setOpen(false);
    context.setIsPopup(false);
    document.querySelector('html').classList.remove('overflow-hidden');
  };

  const handlePublicationClose = () => { // Function for handling publication modal close
    setIsopen(false);
    document.querySelector('html').classList.remove('overflow-hidden');
  };
  // console.log('props', props)
  return (
    <>
      {open && <CustomModal fullScreen={true} isOpen={open} handleClose={handleClose}> {/* Conditional rendering of CustomModal */}
        <PopupPlayer playeris={"live"} isAudioPoster={props.item.thumburl} isPlayer={props.item.video_type} url={props.item.video_type === 'live' ? props.item.download_url : props.item.youtube_url} audioUrl={AudioUrl} isAudio={AudioUrl ?? false ? true : false} handleClose={handleClose} />

        {/* Popup player component */}
      </CustomModal>}
      {/* This iframe will display the PDF from the provided URL */}
      {
        isOpen && props?.item?.video_type === "pdf" && <CustomModal fullScreen={true} isOpen={isOpen} handleClose={handlePublicationClose}>
          <div id="pdf-container">

            <iframe id="pdf-iframe" src={props?.item?.download_url + '#toolbar=1&navpanes=1&scrollbar=0'} allowfullscreen scrolling="auto"></iframe>
          </div>
        </CustomModal>
      }

      {/* Main content */}
      {props.itemIndex === props.index && props.iszoom === true && ( // Conditional rendering based on zoom status
        <ZoomThumbnail // ZoomThumbnail component
          placeHolderSrc={props.type === "v" ? placeHolderV : placeHolderH}
          title={props.item.name}
          item={props.item}
          link={props.link}
          trailerdata={props.item.trailer_data}
          des={props?.item?.description?.toString()}
          itemIndex={props.itemIndex}
          index={props.index}
          thumb={props.thumb}
          muted={muted}
          isMuted={isMuted}
          imgUrl={
            props?.type === 'h' ? props?.item?.thumburl?.size_1080_1920 ? `${props?.item?.thumburl?.size_1080_1920}/width=320/height=180/quality=40` : props?.item?.thumburl?.title_text_1080_1920 ? `${props?.item?.thumburl?.title_text_1080_1920}/width=320/height=180/quality=40` : props?.item?.thumburl?.h_thumburl ? `${props?.item?.thumburl?.h_thumburl}/width=320/height=180/quality=40` : props?.item?.thumburl?.v_thumburl ? `${props?.item?.thumburl?.v_thumburl}/width=320/height=180/quality=40` : `${props?.item?.thumburl?.h_thumburl}/width=320/height=180/quality=40`
              : props?.item?.thumburl?.size_1080_835 ? `${props?.item?.thumburl?.size_1080_835}/width=320/height=414/quality=40` : props?.item?.thumburl?.title_text_1080_835 ? `${props?.item?.thumburl?.title_text_1080_835}/width=320/height=414/quality=40` : props?.item?.thumburl?.v_thumburl ? `${props?.item?.thumburl?.v_thumburl}/width=320/height=414/quality=40` : props?.item?.thumburl?.h_thumburl ? `${props?.item?.thumburl?.h_thumburl}/width=320/height=414/quality=40` : `${props?.item?.thumburl?.v_thumburl}/width=320/height=414/quality=40`
          }
          continueWatching={props.continueWatching}
        />
      )}

      <div className={`position-relative itemBox ${props.type}`}> {/* Main div container */}
        {props.des !== true && ( // Conditional rendering of overlay
          <div
            className="overlay_ transition p-4"
            onClick={() => handelNavigation(props)} // Click handler
          >
            <img src={PlayIcon} alt="play" className="video-play-button" /> {/* Play icon */}
            {props.itemIndex === props.index && ( // Conditional rendering based on item index
              <>
                {props.continueWatching !== false && // Conditional rendering based on continueWatching status
                  props.continueWatching !== undefined &&
                  props.continueWatching !== null ? (
                  <div className="video_played"> {/* Progress bar */}
                    <span style={{ width: `${props.videoplayed}` }}></span>
                  </div>
                ) : (
                  ""
                )}
              </>
            )}
          </div>
        )}

        {/* Placeholder */}
        {props.type === "v" ? ( // Conditional rendering based on type
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={320}
            height={328}
            className="placeholder d-flex align-items-center justify-content-center"
          >
            <img
              src={localStorage.getItem("logo")}
              className="img"
              alt="logo"
            />
          </Skeleton>
        ) : (
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={320}
            height={150}
            className="placeholder d-flex align-items-center justify-content-center"
          >
            <img
              src={localStorage.getItem("logo")}
              className="img"
              alt="logo"
            />
          </Skeleton>
        )}

        <div onClick={() => handelNavigation(props)}> {/* Click handler */}
          <img
            src={props?.type === "v" ? placeHolderV : placeHolderH}
            className="w-100 placeholderImg"
            alt=""
          />

          {/* Lazy loaded image */}
          <LazyLoadImage
            className="w-100 transition imgWrapper"
            effect="blur"
            src={
              props?.type === 'h' ? props?.item?.thumburl?.size_1080_1920 ? `${props?.item?.thumburl?.size_1080_1920}/width=320/height=180/quality=40` : props?.item?.thumburl?.title_text_1080_1920 ? `${props?.item?.thumburl?.title_text_1080_1920}/width=320/height=180/quality=40` : props?.item?.thumburl?.h_thumburl ? `${props?.item?.thumburl?.h_thumburl}/width=320/height=180/quality=40` : props?.item?.thumburl?.v_thumburl ? `${props?.item?.thumburl?.v_thumburl}/width=320/height=180/quality=40` : `${props?.item?.thumburl?.h_thumburl}/width=320/height=180/quality=40`
                : props?.item?.thumburl?.size_1080_835 ? `${props?.item?.thumburl?.size_1080_835}/width=320/height=414/quality=40` : props?.item?.thumburl?.title_text_1080_835 ? `${props?.item?.thumburl?.title_text_1080_835}/width=320/height=414/quality=40` : props?.item?.thumburl?.v_thumburl ? `${props?.item?.thumburl?.v_thumburl}/width=320/height=414/quality=40` : props?.item?.thumburl?.h_thumburl ? `${props?.item?.thumburl?.h_thumburl}/width=320/height=414/quality=40` : `${props?.item?.thumburl?.v_thumburl}/width=320/height=414/quality=40`
            }
            placeholderSrc=""
            alt="Thumb"
          />
        </div>

        {/* Description */}
        {props?.des === true && ( // Conditional rendering based on des status
          <div className={`des ${props.type !== "v" && 'position-relative'}`} onClick={() => handelNavigation(props)}> {/* Click handler */}
            <span className="playIcon d-flex align-items-center justify-content-center rounded-circle"><IoPlayOutline /></span> {/* Play icon */}
            <h6 className="">{props?.item?.name}</h6>
            <p>{parse(typeof props?.item?.description === 'string' ? props.item.description : '')}</p> {/* Parsing and displaying description */}
          </div>
        )}

      </div>
    </>
  );
};

export default CommonCard; // Exporting CommonCard component
